import { useMutation } from '@tanstack/react-query';
import { UpdateUserDto, UserWalletManageService } from 'services/openapi';

type UpdateUserMutationVariables = UpdateUserDto;

export const useUpdateUserMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, UpdateUserMutationVariables>({
      mutationFn: (variables: UpdateUserMutationVariables) => {
        return UserWalletManageService.userManageControllerUpdateUserInfo(
          variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
